import {Injectable, NgZone} from "@angular/core";
import {Subject} from "rxjs";

@Injectable({ providedIn: 'root' })
export class TabGuardService {
  private readonly tabId =
    typeof crypto !== 'undefined' && crypto.randomUUID
      ? crypto.randomUUID()
      : Math.random().toString(36).substr(2, 9); // NOSONAR
  private readonly channel = new BroadcastChannel('TAB_CHANNEL');
  private sessionRevoked = false;
  sessionRevoked$ = new Subject<void>();  // NOSONAR

  constructor(private readonly zone: NgZone) {
    // Listen to messages from other tabs
    this.channel.onmessage = (event) => {
      const { type, tabId } = event.data;

      if (type === 'TAB_ANNOUNCE' && tabId !== this.tabId && !this.sessionRevoked) {
        // Another tab has announced itself — this tab will revoke
        this.revokeSession();
      }
    };

    // Delay our announce to ensure other tabs can pick it up
    setTimeout(() => {
      this.channel.postMessage({ type: 'TAB_ANNOUNCE', tabId: this.tabId });
    }, 500);
  }

  private revokeSession() {
    this.zone.run(() => {
      this.sessionRevoked = true;
      this.sessionRevoked$.next();
    });
  }
}
